import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import {
  PageHeader,
  AccordionItem,
  TeaserListing,
  DecorativeLink,
  Heading,
  ContactInformation,
  Section
} from '@budget-monorepo/shared-ui';
import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';

const AcknowledgmentsPage = (props) => {
  const { data } = props;
  const { content, site } = data;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = content.parent;
  const layoutProps = {
    // eslint-disable-next-line react/prop-types
    above: () => <PageHeader title={content.title} category={content.budgetSection} />,
    pageTitle: content.title,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };
  const getTeaserListing = (section) => {
    const featuredItems = section.tableData.primary.map((item) => {
      let title = item.name;
      if (item.link) {
        const linkProps = {
          href: item.link,
          text: item.name,
          info: item.title,
          showFileIcon: false
        };
        title = <DecorativeLink {...linkProps} />;
      }
      return({
        title,
        date: item.title
      });
    });
    const items = content.sections[0].tableData.secondary.map((item) => ({
      title: item.name,
      date: item.title
    }));
    const listingProps = {
      featuredItems,
      items,
      gridTwoColumns: false,
      contained: true,
      stacked: false
    };
    return<TeaserListing {...listingProps} />;
  };

  // metadata for the page
  const metaTitle = content.title;
  const metaDescription = 'Acknowledgements of the staff that supported the development of the governor\'s budget recommendation.';
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        {content.sections && content.sections.map((section, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Section key={`section-teaser-listing--${index}`}>
            {getTeaserListing(section)}
          </Section>
        ))}
        <Section>
          <Heading text={content.contactHeading} level={5} />
          {content.contactInformation && content.contactInformation.map((contact, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <AccordionItem title={contact.title} info={contact.title} icon={null} key={`contact-accordion--${index}`}>
              {/* eslint-disable-next-line react/no-array-index-key */}
              <ContactInformation {...contact} key={`contact--${index}`} />
            </AccordionItem>
          ))}
        </Section>
      </Layout>
    </Fragment>
  );
};

AcknowledgmentsPage.propTypes = {
  data: PropTypes.object
};

export default AcknowledgmentsPage;

export const query = graphql`
query AcknowledgmentsPageQuery {
  site {
    ...SiteMetadata
  }
  content: pagesJson (fields: { slug: { eq: "/acknowledgements/" }}) {
    title
    contactHeading
    ...contactInformation
    budgetSection
    sections {
      type
      tableData {
        primary {
          name
          title
          link
        }
        secondary {
          name
        }
      }
    }
    # Get the last modified timestamp for the file powering the page
    ...PagesJsonDataTimeStamp
  }
}
`;
